// src/services/endpoints/dataEndpoints.js

import { toast } from "react-toastify";
import { setObjectiveDataAIRedux } from "../../redux/featuresSlice/objectiveDataAI";
import { setSegmentationDataRedux } from "../../redux/featuresSlice/segmantation";
import { apiSlice } from "../apiSlice";
import { ENDPOINTS } from "../config/apiconfig";
import {
  setDescription,
  setRequirement,
  setStatusLoading,
} from "./../../redux/featuresSlice/commonSlice";
import {
  setQuestionsDataOndemandDefault,
  setQuestionsDataOndemandAIGen,
  setObjectivesDataRedux,
} from "./../../redux/featuresSlice/commonSlice";
import { v4 as uuidv4 } from "uuid";

export const dataEndpoints = (builder) => ({
  getUserInfo: builder.query({
    query: () => ({
      url: `${ENDPOINTS.GET_USER_INFO}`,
      method: "GET",
    }),
    keepUnusedDataFor: 0,
    providesTags: ["User"],
  }),

  updateUserInfo: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.UPDATE_USER_INFO,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
        dispatch(
          apiSlice.util.invalidateTags([{ type: "Locations", id: "LIST" }])
        );
      } catch (error) {
        // console.error("Update error:", error);
      }
    },
    invalidatesTags: ["User", "Locations"],
  }),
  getQuestList: builder.query({
    query: ({ order = "DESC", page = 1, limit = 10, status = "" }) => ({
      url: `${ENDPOINTS.QUEST_LIST}`,
      method: "GET",
      params: { order, page, limit, status },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getQuestDetails: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.GET_QUEST_DETAILS}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postActionEditQuestDetails: builder.mutation({
    query: ({ quest_id, action }) => ({
      url: `${ENDPOINTS.ACTION_EDIT_QUEST_DETAILS}/${quest_id}`,
      method: "POST",
      data: { action },
    }),
  }),
  getQuestQuestionsDetails: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.GET_QUEST_QUESTION_LIST}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
  getTakeQuest: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.TAKE_QUEST}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
  postFileTakeQuest: builder.mutation({
    query: ({ formData, participant_id }) => {
      return {
        url: `${ENDPOINTS.POST_QUEST_RECEIPT}/${participant_id}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postAnswer: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_ANSWERS,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  postTakeQuestPractice: builder.mutation({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_TAKE_QUEST_PRACTICE}/${quest_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getTakeQuestPractice: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_TAKE_QUEST_PRACTICE}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postTakeQuestReviewing: builder.mutation({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_QUEST_REVIEWING}/${quest_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  //serach company

  postSearchCompany: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.SEARCH_COMPANY,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  postFirstUpdateInfo: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.FIRT_UPDATE_INFO,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  postUpdateAvatar: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.UPDATE_AVATAR,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  // Ondemand
  getListObjectives: builder.query({
    query: ({ page = 1, limit = 4, status = "" }) => ({
      url: `${ENDPOINTS.GET_OBJECTIVES}`,
      method: "GET",
      params: { page, limit, status },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const dataRespon = await queryFulfilled;

        dispatch(setObjectivesDataRedux(dataRespon.data?.data));
        dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getListObjectivesQuestion: builder.query({
    query: ({ limit = 10, page = 1, objective_id }) => ({
      url: `${ENDPOINTS.GET_OBJECTIVES}/${objective_id}/question`,
      method: "GET",
      params: { limit, page },
    }),
    skip: ({ objective_id }) => !objective_id, // Def
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const dataRespon = await queryFulfilled;

        dispatch(setStatusLoading(true));
        dispatch(setQuestionsDataOndemandDefault(dataRespon.data?.data));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
  postGenObjectivesByAI: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_GEN_AI_OBJECTIVES,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const dataRespon = await queryFulfilled;
        if (dataRespon.data?.data?.length === 0) {
          toast.warning("Objective has reached its limit");
        }
        dispatch(setStatusLoading(true));

        dispatch(setObjectiveDataAIRedux(dataRespon.data?.data));
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getListSegmention: builder.query({
    query: ({ limit = 10, page = 1 }) => ({
      url: `${ENDPOINTS.GET_SEGMENTATIONS}`,
      method: "GET",
      params: { limit, page },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));

        const dataRespon = await queryFulfilled;

        dispatch(setSegmentationDataRedux(dataRespon.data?.data));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postOndemand: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_ON_DEMAND,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  postAIGenQuestion: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.AI_GEN_QUESTION,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const dataRespon = await queryFulfilled;

        const updatedData = dataRespon.data?.data.map((item) => ({
          ...item,
          id: uuidv4(),
          createdAt: Date.now(),
        }));

        dispatch(setQuestionsDataOndemandAIGen(updatedData));
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  getListBusinessLocation: builder.query({
    query: () => ({
      url: `${ENDPOINTS.GET_LOCATION_BUSINESS}`,
      method: "GET",
    }),
    providesTags: ["Locations"],
    // providesTags: (result) => [
    //   { type: "Locations", id: "LIST" },
    //   ...(result?.data?.map(({ id }) => ({ type: "Locations", id })) ?? []),
    // ],
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getListBusinessLocationLatLong: builder.query({
    query: ({ body }) => ({
      url: `${ENDPOINTS.GET_LOCATION_LAT_LONG}`,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postFileUpload: builder.mutation({
    query: ({ formData }) => {
      return {
        url: `${ENDPOINTS.POST_IMAGE_UPLOAD}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("❌ Error posting file:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postAIGenInfo: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.AI_GEN_INFO,
      method: "POST",
      data: body,
    }),
    invalidatesTags: ["User"],

    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const dataRespon = await queryFulfilled;
        dispatch(setDescription(dataRespon.data?.data.description));
        dispatch(setRequirement(dataRespon.data?.data.requirements));

        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),
  postCalculatorIncentive: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.CALCULATOR_INCENTIVE,
      method: "POST",
      data: body,
    }),
  }),
  postCalculatorTokenXP: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.CALCULATOR_TOKEN_XP,
      method: "POST",
      data: body,
    }),
  }),

  postCalculatorMysteryShopper: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.CALCULATOR_MYSTERY_SHOPPER,
      method: "POST",
      data: body,
    }),
  }),
  //Quest Result

  getQuestTakeResult: builder.query({
    query: ({ quest_business_id, location_id }) => ({
      url: `${ENDPOINTS.POST_QUEST_TASK_RESULT}/${quest_business_id}`,
      method: "GET",
      params: location_id ? { location_id } : {},
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        toast.error(error.error?.data?.detail[0].msg || "Something went wrong");

        // setTimeout(() => {
        //   window.location.href = "/";
        // }, 1000);
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  //Quest QR Code
  genQuestQRCode: builder.mutation({
    query: ({ body }) => ({
      url: `${ENDPOINTS.GEN_QR_CODE}`,
      method: "POST",
      data: body,
    }),
  }),

  getPerformance: builder.query({
    query: ({ location_id, segmantation_id }) => ({
      url: `${ENDPOINTS.GET_PERFORMANCE}`,
      method: "GET",
      params: { location_id, segmantation_id },
      keepUnusedDataFor: 0,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getPerformanceDetails: builder.query({
    query: ({ location_id, segmantation_id, option_id, type }) => ({
      url: `${ENDPOINTS.GET_PERFORMANCE_DETAILS}`,
      method: "GET",
      params: { location_id, segmantation_id, type, option_id },
      keepUnusedDataFor: 0,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  //Location
  postFindNewLocation: builder.mutation({
    query: (body) => ({
      url: `${ENDPOINTS.POST_FIND_NEW_LOCATION}`,
      method: "POST",
      data: body,
    }),
    invalidatesTags: ["User", "Locations"],
  }),

  //Top up
  postTopUp: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_TOP_UP,
      method: "POST",
      data: {
        ...body,
        select_currency: body.fiat_currency || "SGD",
        bank_name: "",
      },
    }),
    invalidatesTags: (result, error) => (error ? [] : ["TopUpHistory"]),
  }),
  getTopUpHistory: builder.query({
    query: ({ order = "DESC", page = 1, limit = 10, status = "" }) => ({
      url: `${ENDPOINTS.GET_TOP_UP_HISTORY}`,
      method: "GET",
      params: { order, page, limit, status },
    }),
    providesTags: ["TopUpHistory"],
  }),
});
